<template>
  <div class="my-project-container">
    <h3 class="title">
      <span>我的项目</span>
    </h3>
    <div class="project-list-container" v-if="projectList.length">
      <div class="project-card" v-for="item in projectList" :key="item.id">
        <span class="env" :class="`tag-${getEnvClass(item.env)}`">{{getEnvCName(item.env)}}</span>
        <div class="name">{{item.projectName}}</div>
        <div class="desc">{{item.projectDescript}}</div>
        <div class="date">{{formatTime(item.updateTime)}}</div>
        <el-divider class="divider"></el-divider>
        <div class="members">
          <img v-for="(u,i) in item.project_members.length>3?item.project_members.slice(0,3):item.project_members" :key="u.uid" class="avatar" :class="'avatar'+i" :title="u.user.realName" :src="u.user.avatar" @click="showMemberList(item.project_members)" alt="error" />
          <span class="more" :title="`还有${item.project_members.length-3}位成员`" v-if="item.project_members.length>3" @click="showMemberList(item.project_members)">+{{item.project_members.length-3}}</span>
        </div>
        <div class="btn-box">
          <el-button class="btn" type="text" icon="el-icon-view" title="查看项目文件" @click="viewProjectFile(item.path)"></el-button>
          <el-button class="btn" type="text" icon="el-icon-edit-outline" title="编辑项目" @click="showProjectEdit(item.id)"></el-button>
        </div>
      </div>
    </div>
    <div v-else class="empty-content">
      <p class="empty-text">来创建自己的项目吧~</p>
    </div>
    <!-- 对话框 -->
    <el-dialog :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent">
      <component @getProjectList="getMyProjects" :is="dialog.component" @close="destroyComponent" :pId="pId" :memberList="memberList" />
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { myFilesApi, xpsApi, fileManageApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import { dialogMixin } from "@/common/mixins/";
import projectEdit from "@/views/fileManage/components/projectEdit/index.vue";
import memberList from "./memberList.vue"
export default {
  mixins: [dialogMixin],
  data () {
    return {
      projectList: [],
      pId: '',
      memberList: []
    }
  },
  mounted () {
    this.getMyProjects();
  },
  methods: {
    // 显示项目成员弹窗
    showMemberList (members) {
      this.memberList = members;
      this.setDialog(true, "项目成员", memberList, "750px", "8vh");
    },
    // 查看项目文件
    viewProjectFile (path) {
      let param = {
        path
      }
      this.$store.commit('config/SET_ALL_BTN_RETURN_ROUTER', this.$route.name);
      this.$router.push({ path: '/fileManage/projectDetail', query: param });
    },
    // 显示项目编辑弹窗
    async showProjectEdit (id) {
      this.pId = id;
      const res = await fileManageApi.getProjectEditPower({ id })
      if (res.code === 200 && res.data) {
        this.setDialog(true, "项目编辑", projectEdit, "1200px", "8vh");
      } else {
        this.$message.error(res.message);
      }
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 获取我的项目
    async getMyProjects () {
      showLoading();
      const res = await myFilesApi.getMyProjects();
      if (res.code === 200) {
        this.projectList = res.data;
      }
      hideLoading();
    },
    getEnvCName (eName) {
      let cName;
      switch (eName) {
        case 'web':
          cName = 'web端';
          break;
        case 'app':
          cName = 'App端';
          break;
        case 'wxapp':
          cName = '小程序';
          break;
        case 'h5':
          cName = 'H5应用';
          break;
        default:
          cName = '多端应用'
          break;
      }
      return cName;
    },
    getEnvClass (eName) {
      let envClass;
      switch (eName) {
        case 'web':
          envClass = 'danger';
          break;
        case 'app':
          envClass = 'primary';
          break;
        case 'wxapp':
          envClass = 'default';
          break;
        case 'h5':
          envClass = 'warning';
          break;
        default:
          envClass = 'success'
          break;
      }
      return envClass;
    }
  }
}
</script>

<style lang="scss" scoped>
.my-project-container {
  height: 100%;
  .project-list-container {
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    height: calc(100% - 40px);
    &::-webkit-scrollbar {
      display: none;
    }

    .project-card {
      position: relative;
      margin: 2px 10px 10px 2px;
      padding: 15px;
      min-width: 230px;
      width: calc(33% - 10px);
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .name {
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: 600;
        color: #041677;
      }
      .date {
        font-size: 14px;
        font-weight: 500;
        // color: #041677;
      }
      .desc {
        margin-bottom: 10px;
        font-size: 14px;
        color: #adb4bf;
      }
      .env {
        float: right;
        display: inline-block;
        margin-bottom: 5px;
        padding: 3px 12px;
        color: #303133;
        font-size: 14px;
        border-radius: 4px;
        &.tag-success {
          background-color: #dbeddb;
        }
        &.tag-primary {
          background-color: #abc5de;
        }
        &.tag-danger {
          background-color: #ffe2dd;
        }
        &.tag-warning {
          background-color: #fdecc8;
        }
        &.tag-default {
          background-color: #f8fafc;
        }
      }
      .members {
        position: relative;
        height: 28px;
        .avatar {
          position: absolute;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background-color: #fff;
          cursor: pointer;
          &.avatar1 {
            transform: translateX(70%);
            z-index: 2;
          }
          &.avatar2 {
            transform: translateX(140%);
            z-index: 3;
          }
        }
        .more {
          position: absolute;
          top: 12px;
          left: 70px;
          font-size: 14px;
          font-weight: 600;
          color: #adb4bf;
          cursor: pointer;
        }
      }
      .btn-box {
        position: absolute;
        right: 15px;
        bottom: 10px;
        .btn {
          color: #9a9cb0;
          font-weight: 700;
          font-size: 18px;
          &:hover {
            color: #041677;
          }
        }
      }
      .divider {
        margin: 10px 0;
      }
    }
  }
  .empty-content {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 220px;
    background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/22/1737927985.png");
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center;
    .empty-text {
      font-weight: 500;
      color: #bcbcbc;
    }
  }
}
</style>